const introductionTransitionMs = 275;
const wrapper = "_35sw1c18w6q";
const contentContainer = "_35sc1kyelak";
const content = "_35sc1sd1dxo";
const introductionWrapper = "_35si19vb985";

export { content, contentContainer, introductionTransitionMs, introductionWrapper, wrapper };
import "./_task.style.linaria.module.css";
//# sourceMappingURL=_task.style.js.map
